import DocumentFilterView from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentList/Filters/DocumentFilterView';
import { createSignal } from '@verclam/pulsar';

// No dossier is resolved yet at this point, so `belongsTo` rejects this initial value and the
// derivation hook replaces it on first render.
const documentFiltersSignal = createSignal<DocumentFilterView>(DocumentFilterView.createDefault(null));

export const setDocumentFilters = (filters: DocumentFilterView): void => {
	documentFiltersSignal.value = filters;
};

export default documentFiltersSignal;
